import { css, styled } from '../../hooks/theme';
import { getCssFont } from '../../styles';
import { Tokens } from '../../types';

interface ContainerProps {
  disabled?: boolean;
}

interface PageButtonProps {
  selected?: boolean;
  paginationDisabled?: boolean;
}

export const Container = styled.div<ContainerProps>`
  --pagination-primary-color: ${props => props.theme.colors.neutral.grey[100]};
  --pagination-secondary-color: ${props => props.theme.colors.neutral.grey[0]};
  display: flex;
  ${props => getCssFont(props.theme.font.desktop.paragraph.p2.regular)}
  color: var(--pagination-primary-color);
  filter: ${props => (props.disabled ? 'grayscale(1) opacity(0.4)' : 'none')};
  height: 2.25rem;
`;
Container.defaultProps = {
  theme: Tokens.eixods,
};

export const PagesContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const PageButton = styled.button<PageButtonProps>`
  width: 2.25rem;
  height: 2.25rem;
  padding: 0.5rem;

  cursor: pointer;

  background: ${props =>
    props.selected
      ? props.theme.colors.brand.primary[100]
      : css`var(--pagination-secondary-color)`};
  color: ${props =>
    props.selected ? css`var(--pagination-secondary-color)` : css`var(--pagination-primary-color)`};
  ${props => getCssFont(props.theme.font.desktop.paragraph.p2.regular)}
  border: none;
  border-radius: 4px;
  transition: 0.2s background;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: ${props =>
      !props.selected && !props.paginationDisabled && props.theme.colors.neutral.grey[5]};
  }
`;
PageButton.defaultProps = {
  theme: Tokens.eixods,
};

export const SkipButton = styled.button<PageButtonProps>`
  width: 2.25rem;
  height: 2.25rem;
  color: var(--pagination-primary-color);

  cursor: pointer;
  border: none;
  background: none;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TakeContainer = styled.div`
  margin-left: 56px;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  white-space: nowrap;
  button {
    ${props => getCssFont(props.theme.font.desktop.paragraph.p2.regular)}
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
`;

export const TakeSelector = styled.button`
  position: relative;
  padding: 0.3125rem 1rem;

  box-sizing: content-box;
  background: var(--pagination-secondary-color);
  border: 1px solid ${props => props.theme.colors.neutral.grey[40]};
  color: var(--pagination-primary-color);
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
`;
TakeSelector.defaultProps = {
  theme: Tokens.eixods,
};

export const TakeDropdown = styled.div`
  position: absolute;
  top: 43px;
  left: 0;

  z-index: inherit;

  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.06);

  display: flex;
  flex-direction: column;
`;

export const TakeButton = styled.button`
  min-width: 80px;
  height: 2.25rem;

  border: none;
  color: var(--pagination-primary-color);
  background: var(--pagination-secondary-color);
  transition: background 0.1s;
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.neutral.grey[10]};
  }
`;
TakeButton.defaultProps = {
  theme: Tokens.eixods,
};
